// MobileNumberInput.js
import React, { useState } from 'react';
import { TextField, InputAdornment, IconButton } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

const MobileNumberInput = ({ mobile, setMobile, errors, isOnSiteRegistration }) => {
  const [showMobile, setShowMobile] = useState(true);

  const toggleShowMobile = () => setShowMobile(!showMobile);

  return (
    <TextField
      fullWidth
      value={mobile}
      onChange={(e) => {
        const value = e.target.value;

        // sirf numbers allow
        if (!/^\d*$/.test(value)) return;

        // 10 digits se zyada allow nahi
        if (value.length > 10) return;

        if (value.length === 10 && !/^[6-9]\d{9}$/.test(value)) {
          errors.mobile = "Invalid mobile number";
        } else {
          delete errors.mobile;
        }

        setMobile(value);
      }}
      disabled={mobile.length === 10 && !isOnSiteRegistration }
      error={!!errors?.mobile}
      helperText={errors?.mobile}
      inputProps={{
        maxLength: 10,
        autoComplete: 'off',
        style: { paddingRight: '40px' }
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start" sx={{ mr: 0.5 }}>
            +91
          </InputAdornment>
        ),
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              onClick={toggleShowMobile}
              edge="end"
              size="small"
              tabIndex={-1}
            >
              {showMobile ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
            </IconButton>
          </InputAdornment>
        ),
      }}
      type={showMobile ? 'password' : 'text'}
      label="Mobile Number *"
      variant="outlined"
    //   size="small"
    />
  );
};

export default MobileNumberInput;